import React, { useEffect, useState } from "react";
import { CapitalType } from "../../context/AppContext";
import useValidation from "../../hooks/useValidation";
import * as yup from "yup";

interface CapitalChangeProps {
    inputLabel: string;
    fieldKey: string;
    capital: CapitalType;
    checked: boolean;
    onChange: (data: Partial<CapitalType>) => void;
    onValidationChange: (isValid: boolean) => void;
}

const capitalChangeValidationSchema = yup.object().shape({
    capital: yup
        .number()
        .required("Le capital est requis")
        .positive("Le capital doit être positif"),
});

const CapitalChange: React.FC<CapitalChangeProps> = ({
    inputLabel,
    fieldKey,
    capital,
    checked,
    onChange,
    onValidationChange,
}) => {
    const [inputValue, setInputValue] = useState<string>(
        capital.capital.toString().replace(".", ",")
    );

    const { errors, isValid } = useValidation(capital, capitalChangeValidationSchema );

    useEffect(() => {
        onValidationChange(isValid);
    }, [isValid, onValidationChange]);

    useEffect(() => {
        setInputValue(capital.capital.toString().replace(".", ","));
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        value = value.replace(".", ",");

        if (/^(\d+([,]\d{0,2})?)?$/.test(value)) {
            setInputValue(value);

            const numericValue = parseFloat(value.replace(",", "."));
            if (!isNaN(numericValue)) {
                onChange({ capital: numericValue }); // Mettez à jour correctement l'objet
            } else {
                onChange({ capital: 0 }); // Si la saisie est vide, définissez le capital à 0
            }
        }
    };

    return (
        <div className = "row mb-3">
            <label htmlFor="capital" className="col-sm-2 col-form-label">
                {inputLabel} <strong className="text-danger">*</strong>
            </label>

                <div className="col-6">
                    <span
                        style={{
                            position: "absolute",
                            marginTop: "9px",
                            marginLeft: "10px",
                        }}
                    >
                        {parseFloat(inputValue.replace(",", ".")) > 0 && "€"}
                    </span>

                <input
                    className={`description-input ${
                        capital.capital !== 0 ? "ps-4" : ""
                    } form-control ${
                        checked && errors.capital ? "is-invalid" : ""
                    }`}
                    type="text"
                    id="capital"
                    value={inputValue !== "0" ? inputValue : ""}
                    onChange={handleChange}
                />
                {checked && errors.capital && (
                    <div className="invalid-feedback">{errors.capital}</div>
                )}
            </div>
        </div>
    );
};

export default CapitalChange;